import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DirectivesModule } from '../../directives/directives.module';
import { DropdownModule } from '../dropdown/dropdown.module';
import { SelectGridModule } from '../select-grid/select-grid.module';
import { TranslateModule } from '@ngx-translate/core';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { DatePickerRangeComponent } from './date-picker-range.component';
import { DatePickerModule } from '../date-picker/date-picker.module';
import { FormsModule } from '@angular/forms';
import { TooltipModule } from '../tooltip/tooltip.module';
import { SelectPanelModule } from '../select-panel/select-panel.module';

@NgModule({
  declarations: [DatePickerRangeComponent],
  exports: [DatePickerRangeComponent],
  entryComponents: [DatePickerRangeComponent],
  imports: [
    CommonModule,
    FormsModule,
    TranslateModule,
    AngularSvgIconModule,
    SelectGridModule,
    DirectivesModule,
    DropdownModule,
    DatePickerModule,
    TooltipModule,
    SelectPanelModule
  ]
})
export class DatePickerRangeModule {}

export { DatePickerRangeComponent };
export * from './date-picker-range.type';
